module.exports = __webpack_public_path__ + "img/coo_delivery.5e11ea76.png";